import { useEffect, useState } from 'react';
import { useAPIPost, useRoboScreener } from '../API';

export function useSurveyTopology(props: any) {

  const [dmap, setDmap] = useState({} as Record<string, string[]>);
  const [pdmap, setPdmap] = useState({} as Record<string, string[]>);

  const [depsError, setDepsError] = useState('');

  const [loadingDeps, setLoadingDeps] = useState(true); // We will load immediately.

  const [queue, setQueue] = useState({} as Record<string, number>);

  const getDeps = useRoboScreener("/get_deps");

  useEffect(() => {
    setLoadingDeps(true);
    (async () => {

      const response = await getDeps({});

      console.log("Got response: ", response);
      if ('value' in response) {
        console.log("Setting dmap to: ", response.value.dmap);
        setDmap(response.value.dmap);
        setPdmap(response.value.pdmap);
        const qu = {} as Record<string, number>;
        response.value.queue.forEach((x: number, index: number) => {
          qu[response.value!.vertices[x]] = index;
        })
        setQueue(qu);
      }
      if ('error' in response) {
        setDepsError(response.error);
      }
    })();

    setLoadingDeps(false);
  }, [])

  return {
    dmap,
    pdmap,
    depsError,
    loadingDeps,
    queue
  }
}
